<template>
  <v-card class="px-3 py-3">
    <div v-if="!duzenle">
      <h2 class="subtitle-1 mb-2">
        <v-icon left style="top:-2px">mdi-plus-circle</v-icon>Yeni Bir Ürün Listesi Oluştur
      </h2>
    </div>
    <div v-else>
      <div class="d-flex justify-space-between">
        <h2 class="subtitle-1 mb-2">
          <v-icon left style="top:-2px">mdi-plus-circle</v-icon>Ürün Listesini Düzenle
        </h2>
        <v-btn rounded x-small color="red darken-2" dark @click="sifirla">
          <v-icon size="13" left>mdi-cancel</v-icon>İptal
        </v-btn>
      </div>
    </div>
    <v-divider></v-divider>
    <div class="mb-4">
      <transition-group name="list" tag="div">
        <div :key="1" v-show="urunListeStep === 1">
          <div class="mb-5">
            <v-text-field
              label="Liste Adı"
              hint="Örn: Kampanyalar"
              class="font-weight-light"
              persistent-hint
              prepend-icon="mdi-rename-box"
              v-model="urunListesiData.listeAdi"
            />
            <v-text-field
              label="Liste Açıklaması"
              hint="Liste için bir açıklama getirin (Zorunlu Değil)"
              class="font-weight-light"
              persistent-hint
              prepend-icon="mdi-text"
              v-model="urunListesiData.listeAciklamasi"
            />
          </div>
          <div class="pl-8">
            <v-btn color="blue" class="px-8" small dark @click="urunListeStep = 2">
              İleri
              <v-icon right>mdi-chevron-right</v-icon>
            </v-btn>
          </div>
        </div>
        <div class="py-2" :key="2" v-show="urunListeStep === 2">
          <div class="mb-4">
            <v-text-field
              v-model="autoComplete.model"
              :loading="autoComplete.isLoading"
              label="Ürünleri seç"
              placeholder="Ürün listesinde arama yapın"
              hint="Listeden eklemek istediğiniz ürünleri seçin"
              prepend-icon="mdi-database-search"
              persistent-hint
              class="font-weight-light"
              @keyup="aramaYap"
              clearable
            ></v-text-field>
          </div>
          <div class="secili-urunler" :key="3" v-show="autoComplete.items">
            <v-tabs v-model="urunListeTab" fixed-tabs>
              <v-tab class="text-overline">Arama Sonucu</v-tab>
              <v-tab class="text-overline">
                <v-badge
                  v-if="seciliUrunler.length > 0"
                  color="green"
                  :content="seciliUrunler.length"
                >Seçilen Ürünler</v-badge>
                <span v-else>Seçilen Ürünler</span>
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="urunListeTab">
              <v-tab-item class="pt-5 pb-2">
                <div v-if="autoComplete.items.length > 0">
                  <div
                    class="d-flex align-center justify-space-between mb-2"
                    :key="key"
                    v-for="(urun, key) in autoComplete.items"
                  >
                    <div class="text-caption d-flex align-center">
                      <v-img
                        src="http://192.168.1.17/api//images/urunler/resized/460/318/urun-28-01-2021-1611863043-10.jpg"
                        width="30px"
                        height="30px"
                        class="mr-2"
                      ></v-img>
                      <div>
                        <span class="font-weight-bold">{{urun.name}}</span>
                        <br />
                        {{urun.kod}}
                      </div>
                    </div>
                    <div>
                      <v-btn x-small color="blue" dark fab @click="urunEkle(urun.code)">
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </div>
                <div class="text-center text-overline grey--text" v-else>
                  <p class="mb-0" v-if="searchCount === 0">
                    <v-icon left>mdi-information-outline</v-icon>Arama sonucuna uygun ürün bulunamadı
                  </p>
                  <p class="mb-0" v-else>
                    <v-icon left>mdi-information-outline</v-icon>Ürün listelemek için arama yapınız
                  </p>
                </div>
              </v-tab-item>
              <v-tab-item class="pt-5 pb-2">
                <div v-if="seciliUrunler.length > 0">
                  <div
                    class="d-flex align-center justify-space-between mb-2"
                    :key="key"
                    v-for="(urun, key) in seciliUrunler"
                  >
                    <div class="text-caption d-flex align-center">
                      <v-img
                        src="http://192.168.1.17/api//images/urunler/resized/460/318/urun-28-01-2021-1611863043-10.jpg"
                        width="30px"
                        height="30px"
                        class="mr-2"
                      ></v-img>
                      <div>
                        <span class="font-weight-bold">{{urun.name}}</span>
                        <br />
                        {{urun.kod}}
                      </div>
                    </div>
                    <div>
                      <v-btn x-small color="red darken-2" dark fab @click="remove(urun.code)">
                        <v-icon>mdi-minus</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </div>
                <div class="text-center text-overline grey--text" v-else>
                  <p class="mb-0">Ürün seçimi yapılmadı</p>
                </div>
              </v-tab-item>
            </v-tabs-items>
          </div>
        </div>
      </transition-group>
    </div>
    <div v-if="urunListeStep === 2">
      <div v-if="!duzenle" class="d-flex justify-space-between">
        <div>
          <v-btn
            color="black"
            class="px-5 mr-3 font-weight-light"
            outlined
            small
            dark
            @click="urunListeStep = 1"
          >
            <v-icon left>mdi-arrow-left-bold</v-icon>Önceki
          </v-btn>
          <v-btn
            color="red darken-2"
            class="px-5 font-weight-light"
            outlined
            small
            dark
            @click="sifirla"
          >
            <v-icon left>mdi-cancel</v-icon>İptal
          </v-btn>
        </div>
        <v-btn color="blue" class="px-8" small dark @click="listeEkle">
          <v-icon left>mdi-plus-circle</v-icon>Oluştur
        </v-btn>
      </div>
      <div v-else class="d-flex justify-space-between">
        <div>
          <v-btn
            color="black"
            class="px-5 mr-3 font-weight-light"
            outlined
            small
            dark
            @click="urunListeStep = 1"
          >
            <v-icon left>mdi-arrow-left-bold</v-icon>Önceki
          </v-btn>
          <v-btn
            color="red darken-2"
            class="px-5 font-weight-light"
            outlined
            small
            dark
            @click="sifirla"
          >
            <v-icon left>mdi-cancel</v-icon>İptal
          </v-btn>
        </div>
        <v-btn color="green" class="px-8" small dark @click="listeGuncelle">
          <v-icon left>mdi-refresh</v-icon>Güncelle
        </v-btn>
      </div>
    </div>
  </v-card>
</template>

<script>
import _ from "lodash";
export default {
  name: "UrunListesiEkle",
  props: {
    duzenle: {
      default: false,
      required: false
    }
  },
  data: () => ({
    urunListesiData: {
      listeAdi: "",
      listeAciklamasi: "",
      listeUrunleri: ""
    },
    autoComplete: {
      isLoading: false,
      model: null,
      search: null,
      items: []
    },
    seciliUrunler: [],
    urunListeStep: 1,
    urunListeTab: null,
    searchCount: null,
  }),
  methods: {
    urunEkle(urunCode) {
      let urun = _.find(this.autoComplete.items, o => {
        return o.code === urunCode;
      });
      this.seciliUrunler.push(urun);
      this.$snotify.success("Ürün listeye eklendi", this.$t('PANEL.NOTIFY.SUCCESS'));
    },
    remove(urunCode) {
      const index = _.remove(this.seciliUrunler, o => {
        return o.code !== urunCode;
      });
      this.seciliUrunler = index;
    },
    aramaYap(e) {
      var ara = e.target.value;
      if (ara === null) return false;
      if (ara.length > 2) {
        this.isLoading = true;
        const type = "name",
          kategori = "",
          baslangic = 0,
          limit = 10;
        this.$store
          .dispatch("Urunler/UrunList/urunAra", {
            ara,
            type,
            kategori,
            baslangic,
            limit
          })
          .then(res => {
            this.autoComplete.items = res.data;
            this.searchCount = res.data.length;
          })
          .then(() => {
            this.autoComplete.isLoading = false;
          });
      }
    },
    /**
     * Formu sıfırla
     */
    sifirla() {
      this.$set(this.urunListesiData, "listeAdi", "");
      this.$set(this.urunListesiData, "listeAciklamasi", "");
      this.$set(this.urunListesiData, "listeUrunleri", []);
      this.$set(this.autoComplete, "model", "");
      this.$set(this.autoComplete, "items", []);
      this.seciliUrunler = [];
      this.urunListeStep = 1;
      this.$emit('clear', false)
    },
    listeEkle() {
      const { listeAdi, listeAciklamasi, listeUrunleri } = this.urunListesiData;
      this.$store
        .dispatch("Urunler/UrunListeleri/urunListeEkle", {
          listeAdi,
          listeAciklamasi,
          listeUrunleri
        })
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success(
              "Ürün listesi başarılı bir şekilde eklenmiştir",
              this.$t('PANEL.NOTIFY.SUCCESS')
            );
            this.sifirla();
          } else {
            this.$snotify.error(res.data.errMessage, this.$t('PANEL.NOTIFY.ERROR'));
          }
        });
    },
    listeGuncelle() {
      const { listeAdi, listeAciklamasi, listeUrunleri } = this.urunListesiData,
              listeID = this.duzenle.id
      this.$store
        .dispatch("Urunler/UrunListeleri/urunListeGuncelle", {
          listeID,
          listeAdi,
          listeAciklamasi,
          listeUrunleri
        })
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success(
              "Ürün listesi başarılı bir şekilde güncellenmiştir",
              this.$t('PANEL.NOTIFY.SUCCESS')
            );
            this.sifirla();
          } else {
            this.$snotify.error(res.data.errMessage, this.$t('PANEL.NOTIFY.ERROR'));
          }
        });
    }
  },
  mounted() {
    /**
     * Düzenle verisi değişim gösterdiğinde liste detayını
     * ilgili alanlara aktar
     */
    if (this.duzenle) {
      this.$set(this.urunListesiData, "listeAdi", this.duzenle.baslik);
      this.$set(this.urunListesiData, "listeAciklamasi", this.duzenle.aciklama);
      this.seciliUrunler = this.duzenle.urunler;
    }
  },
  watch: {
    seciliUrunler(val) {
      this.urunListesiData.listeUrunleri = _.map(val, o => {
        return o.code;
      });
    },
    "autoComplete.model"(val) {
      if (val === null || val === "") {
        this.autoComplete.items = [];
        this.searchCount = null;
      }
    }
  }
};
</script>

<style>
.w-100 {
  width: 100%;
}
.list-item {
  display: inline-block;
  margin-right: 10px;
}
.list-enter-active {
  transition: all 1s;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
</style>